import { request } from '@blade/common';
export const getSceneRules = () => request.get('/api/iot-device-management/api/v2/iot/device/bgImage/rule');
export const addDeviceBG = (data) => request.post('/api/iot-device-management/api/v2/iot/device/bgImage/', data);
export const updateDeviceBG = (data) => request.put('/api/iot-device-management/api/v2/iot/device/bgImage/', data);
export const fetchLastData = (imageId) => request.get(`/api/iot-device-management/api/v2/iot/device/bgImage/${imageId}`);
export const getEquipmentList = () => request.get(`/api/iot-device-management/api/v2/iot/devicegroups/list`);
export const getBackgroundList = (data) => request({
    url: '/api/iot-device-management/api/v2/iot/device/bgImage/list',
    method: 'POST',
    data
});
export const deletetBackground = (id) => request({
    url: `/api/iot-device-management/api/v2/iot/device/bgImage/${id}`,
    method: 'DELETE',
});
